export class RackPositionId{
    rackPositionId:number;
    constructor(rackPositionId:number){
    this.rackPositionId = rackPositionId;
    }
} 
